const blog = {
    title: 'Blog',
    seeAll: 'Zobacz wszystkie wpisy',
}

export default blog
